import { createContext } from "react";
//app.js context
export const UserInfo = createContext(null);
export const NotificationInfo = createContext(null);
export const PermissionInfo = createContext(null);
